import {asyncDelay, evaluateFunction} from "@wix/devzai-utils-common";
import {
    elementStartsInsideVerticalScrollParentViewport,
    elementVerticallyScrollToInScrollParent
} from "@wix/devzai-utils-dom";

export function doppeActionWidgetPerformWidgetContentReplacement (
    widgetRootElement: HTMLElement | null,
    widgetContentReplacementFunction: () => void
) {
    doppeActionWidgetPerformWidgetContentReplacementInner(
        widgetRootElement,
        widgetContentReplacementFunction,
        false)
}

function doppeActionWidgetPerformWidgetContentReplacementInner (
    widgetRootElement: HTMLElement | null,
    widgetContentReplacementFunction: () => void,
    animated: boolean
) {
    void evaluateFunction(async () => {
        if (widgetRootElement) {
            if (!elementStartsInsideVerticalScrollParentViewport(widgetRootElement)) {
                await elementVerticallyScrollToInScrollParent(widgetRootElement, {
                    marginTop: 24,
                    scrollBehaviour: animated ? 'smooth' : 'instant'
                });

                if (animated) {
                    await asyncDelay(16 * 4);
                }
            }
        }

        widgetContentReplacementFunction();
    })
}